import * as React from "react";
import { Text, TouchableOpacity, StyleSheet } from "react-native";
import Icon from "react-native-vector-icons/MaterialCommunityIcons";

import { colors, radius } from "../../theme/modern";

export default class NumberKeyComponent extends React.PureComponent {
  onChangeNumberKeyClick = () =>
    this.props.onChangeNumberKeyClick(this.props.text);

  render() {
    const { text } = this.props;
    // amounts such as 100 or 500 fill in the whole value at once
    const quick = text.length > 2 && text !== "Del";

    return (
      <TouchableOpacity
        activeOpacity={0.6}
        onPress={this.onChangeNumberKeyClick}
        style={[styles.key, quick ? styles.quick : null]}
      >
        {text === "Del" ? (
          <Icon name="backspace" size={22} color={colors.textMuted} />
        ) : (
          <Text style={[styles.text, quick ? styles.quickText : null]}>
            {text}
          </Text>
        )}
      </TouchableOpacity>
    );
  }
}

const styles = StyleSheet.create({
  key: {
    flex: 1,
    height: 60,
    margin: 5,
    borderRadius: radius.medium,
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: colors.surface,
    borderWidth: 1,
    borderColor: colors.border,
  },
  quick: {
    backgroundColor: colors.primarySoft,
    borderColor: colors.primarySoft,
  },
  text: {
    fontSize: 22,
    fontWeight: "600",
    color: colors.text,
  },
  quickText: {
    fontSize: 17,
    fontWeight: "700",
    color: colors.primary,
  },
});
